export const tips = [
  'The largest DNA methylation adult cheek swab dataset ever generated was created by our team of scientists at Tally Health.',
  'Aging is a primary risk factor for many of the common diseases and conditions that cause most deaths, including cancer, dementia and cardiovascular disease.',
  'Autophagy, which declines with age, refers to a cellular recycling program that removes old and damaged cellular components, such as mitochondria and proteins.',
];
